"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var autoJoinRoles_exports = {};
__export(autoJoinRoles_exports, {
  setWorkspaceGuestAutoJoinRoles: () => setWorkspaceGuestAutoJoinRoles
});
module.exports = __toCommonJS(autoJoinRoles_exports);
var import_classes = require("./classes");
function setWorkspaceGuestAutoJoinRoles(existing, includeGuest) {
  const next = new Set(existing ?? []);
  if (includeGuest) {
    next.add(import_classes.AccountRole.Guest);
  } else {
    next.delete(import_classes.AccountRole.Guest);
  }
  return Array.from(next);
}
__name(setWorkspaceGuestAutoJoinRoles, "setWorkspaceGuestAutoJoinRoles");
//# sourceMappingURL=autoJoinRoles.js.map
